export default __webpack_public_path__ + "static/media/planner_green.e07fd9b4.svg";